import { enqueueGradeRpc, getGradeRpc } from '../../__generated__/chirp/com/hubspot/websitegrader/rpc/WebsiteGraderRpcService';
import { DOMAIN_INVALID } from '../constants/ErrorTypes';
import chirpClient, { getRequestMetadata } from './chirpClient';
const timeout = 60000;
export default class GraderAPI {
  async get(websiteUrl) {
    const result = await chirpClient.callWithResultUnion(getGradeRpc, {
      request: Object.assign({
        domain: websiteUrl
      }, getRequestMetadata()),
      timeout
    });
    if (result.type === 'rpcError') {
      const {
        errorType,
        errorMessage
      } = result.rpcError;
      if (typeof errorType !== 'string') {
        throw new Error('Website grading failed');
      }
      throw Object.assign(new Error(errorMessage || errorType), {
        status: 400,
        responseJSON: Object.assign({}, result.rpcError, {
          errorType: errorType === 'INVALID_DOMAIN' ? DOMAIN_INVALID : errorType
        })
      });
    }
    const {
      status,
      gradeResult
    } = result.data;
    if (status === 'NOT_FOUND') {
      throw Object.assign(new Error('Website grade not found'), {
        status: 404
      });
    }
    if (status === 'IN_PROGRESS') {
      return {
        status: 202
      };
    }
    if (status === 'READY' && gradeResult) {
      return {
        status: 200,
        responseJSON: Object.assign({}, gradeResult, {
          performanceAudit: Object.assign({}, gradeResult.performanceAudit, {
            loadTime: gradeResult.performanceAudit.loadTimeMillis
          })
        })
      };
    }
    throw new Error('Unexpected website grade response');
  }
  async post(websiteUrl) {
    await chirpClient.call(enqueueGradeRpc, {
      request: Object.assign({
        domain: websiteUrl
      }, getRequestMetadata()),
      timeout
    });
    return {
      status: 202
    };
  }
}